import { useState, useEffect } from "react";
import axios from "axios";
import "../styles/Register.css";
import BASE_URL from "../BaseUrl";
import CircularProgress from '@mui/material/CircularProgress';

export default function Register({setActive}) {

  const [error, setError] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [acceptedInputs, setAcceptedInputs] = useState(true);
  const [showOTPForm, setShowOTPFrom] = useState(false);
  const [OTP, setOTP] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [otpResent, setOtpResent] = useState(false);
  const [filePhoto, setFilePhoto] = useState(null);
  const [reload, setReload] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [user, setUser] = useState({
    id:"",
    name: "",
    email: "",
    phone: "",
    field:"",
    password: "",
    confirmpassword: ""
  });

  const forbiddenPattern = /[<>/{}/=]/;
  const forbiddenSQL = /\b(SELECT|INSERT|UPDATE|DELETE|DROP|ALTER|CREATE|TRUNCATE|EXEC|UNION)\b/i;


  function sendOTP(){
    setDisabledButton(true);
      if(!acceptedInputs){
        setDisabledButton(false);
        return;
      }
      
      axios.post(`${BASE_URL}/auth/otp`,{"otp":OTP, email:user.email},{withCredentials: true,
        headers:{ "Content-Type": "application/json" }
      })
      .then((response)=>{
        setMessage(response.data);
        setShowOTPFrom(false);
        setOTP("");
        setDisabledButton(false);
        setUser({
          id:"",
          name: "",
          email: "",
          phone: "",
          field:"",
          password: "",
          confirmpassword: ""
        })
        setShowMessage(true);
      }).catch((error)=>{
        if(error.response){
          setMessage(error.response.data);
          setShowMessage(true);
          return;
        }
        console.log(error);
      })
  }

  function resendOTP(){
    axios.get(`${BASE_URL}/auth/resendOTP?email=${user.email}`,{withCredentials:true})
    .then((response)=>{
      setOtpResent(true);
    }).catch((error)=>{
      setMessage(error.response.data);
      setShowMessage(true);
    })
  }
  const checkInput = (e) => {
    const inputValue = e.target.value;
    if (forbiddenPattern.test(inputValue) || forbiddenSQL.test(inputValue)) {
      setAcceptedInputs(false);
      e.target.style.borderColor = "red";
    } else{
      setAcceptedInputs(true);
    }
  };

  const handleChange = (e) => {
      e.target.style.border= "var(--bs-border-width) solid var(--bs-border-color)";
      checkInput(e);
    setUser({ ...user, [e.target.name]: e.target.value });
  }

  const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        
        setFilePhoto(file);
      };

  const sendData = async (e) => {
    setDisabledButton(true);
    var isValid = true;
    e.preventDefault();
    if(!acceptedInputs){
      setDisabledButton(false);
      return;
    }
    if(!filePhoto){
      alert("الرجاء اختيار صورة");
      isValid = false;
    }
    if(user.name.trim() === ""){
      document.getElementById("name").style.borderColor = "red";
      isValid = false;
    }
    if(user.email.trim() === ""){
      document.getElementById("email").style.borderColor = "red";
      isValid = false;
    }
    if(user.phone.trim() === ""){
      document.getElementById("phone").style.borderColor = "red";
      isValid = false;
    }
    if(user.field.trim() === ""){
      document.getElementById("field").style.borderColor = "red";
      isValid = false;
    }
    if(user.password.trim() === ""){
      document.getElementById("password").style.borderColor = "red";
      isValid = false;
    }
    if(!isValid){
      setDisabledButton(false);
      return;
    }
    if (user.password !== user.confirmpassword) {
      setError("تأكيد كلمة المرور غير متطابق");
      setShowPopup(true);
      return;
    }
    var formData = new FormData();
    formData.append("user", new Blob([JSON.stringify(user)], {
    type: "application/json",
  }));
    formData.append("file", filePhoto);
    axios.post(`${BASE_URL}/auth/register`, formData, { withCredentials: true})
      .then((response) => {
        setDisabledButton(false);
        setShowOTPFrom(true);
      })
      .catch((error) => {
        if(error.response === undefined){
          setError("خطأ في الخادم");
        }
        else{
          if(error.response.status === 409){
            alert(error.response.data);
            setShowOTPFrom(true);
            return;
          }

          console.log(error.data)        
        }
        setDisabledButton(false);
        setShowPopup(true);
      });
  }

  useEffect(()=>{
    setActive("تسجيل الدخول");
  },[setActive])
  return (
    <div className="container">
      <h1 >تسجيل معلم جديد</h1>
      <form 
        style={{justifyItems:"center"}}
      >
        <div className= "admin-photo-div"
          style={{
            alignItems:"center",
            justifyItems:"center",
          }}
        >
            <div style={{width:"150px",height:"150px"}}>
            <img
            src={
            filePhoto
            ? URL.createObjectURL(filePhoto)
            : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png" 
            }
            alt="avatar"
            className="avatar"
            />
            </div>
        <label
            style={{width:"100%", justifyItems:"right",textAlign:"right", display:"block"}}
            >
            
            <input
            id="fileInput"
                dir="rtl"
                type="file"
                accept="image/*"
                placeholder="اختر صورة"
                style={{ display: "block" }}
                onChange={handleFileChange}
            />
            </label>
        </div>
        
          <label htmlFor="name" className="form-label">
            الاسم
          </label>
          <input className="form-control" dir="rtl" lang="ar" type="text" id="name" name="name" required 
          onChange={(e)=>{handleChange(e)}} />
          <label htmlFor="email"className="form-label">
            البريد الالكتروني
          </label>
          <input className="form-control" type="email" id="email" name="email" required 
          onChange={(e)=>{handleChange(e)}} />
          <label htmlFor="phone" className="form-label">
            رقم الهاتف
          </label>
          <input maxLength="11" className="form-control" type="text" id="phone" name="phone" required 
          onChange={(e)=>{handleChange(e)}} />
          <label htmlFor="field" className="form-label">
            التخصص
          </label>
          <input className="form-control" type="text" id="field" name="field" required 
          onChange={(e)=>{handleChange(e)}} />
          <label htmlFor="password" className="form-label">
            كلمة المرور
          </label>
          <input className="form-control" type="password" id="password" name="password" required 
          onChange={(e)=>{handleChange(e)}} />
          <label htmlFor="confirmpassword" className="form-label">
            تأكيد كلمة المرور
          </label>
          <input className="form-control" type="password" id="confirmpassword" name="confirmpassword" required 
          onChange={(e)=>{handleChange(e)}} />

        <button 
        disabled={disabledButton}
        type="button" onClick={sendData} className="btn btn-primary log-in-button">
          {disabledButton ? <CircularProgress size={24} color="white" /> : "تسجيل"}
        </button>
      </form>
      {showPopup && (
        <div className="signin-popup-overlay">
          <div className="signin-popup">
            <h2>فشل تسجيل الدخول </h2>
            <p>{error}</p>
            <button onClick={() => setShowPopup(false)} className="btn btn-danger">
              Close
            </button>
          </div>
        </div>
      )}

      { showOTPForm && (
                <div className="overlay">
                <div className="otp-form">
                    <h3>ادخل الرمز الذي تم ارساله الي {user.email}</h3>
                    <div style={{display:"flex",
                      justifyContent:"center",
                      paddingRight:"20px"
                    }}>
                    <p style={{
                      fontSize:"small",
                      margin:"0px",
                      textAlign:"center",
                      paddingTop:"4%",
                      paddingRight:"10px",
                      textDecorationLine:"underline",
                      cursor:"pointer"
                    }} onClick={resendOTP}>إعادة إرسال الرمز</p>
                    <input
                        type="text"
                        value={OTP}
                        onChange={(e) => {
                          handleChange(e);
                          setOTP(e.target.value)}}
                        placeholder="ادخل الرمز"/>
                    <button 
                    disabled={disabledButton}
                    onClick={sendOTP} >{disabledButton ? <CircularProgress size={24} color="white" /> : "ارسال"}</button>
                    </div>
                    {otpResent&&(
                      <p>تم إعادة ارسال الرمز</p>
                    )}
                </div>
                </div>
                 )}

                 { showMessage && (
                    <div className="overlay">
                        <div className="home-owner-message">
                            <p>{message}</p>
                            <button onClick={() => setShowMessage(false)}>اغلاق</button>
                        </div>
                    </div>
            )}
    </div>
  );
}
